<template>
  <main-layout :selectedMenu="'activity'">
    <div class="banner">
    </div>
    <div class="container">
        <div class="left-wrap">
            <div class="left">
                <div class="head" v-for="(item,index) in contentTab" :key="index"  :class="{choose:index===contentIndex}" @click="changeIndex(index)">{{item}}</div>
            </div>
            <div class="left-content">
                <div class="title"> MANA{{$t('global.全球艺术网络科技公司')}} </div>
                <div class="type">{{$t('global.全球新媒体艺术平台')}}</div>
                <div class="bjimg"></div>
                <div class="special-content">
                    <p>{{$t('global.公司简介')}}：</p>

                    <p>MANA是一家致力于全球艺术视频的综合平台，我们为推进全球范围内的艺术视频为己任</p>

                    <p>“流明数码艺术大奖”组织由众多艺术界知名人士组成，其每年在全球各国征集经由电子数码设备所创作而成的艺术作品，并通过专业的评审团选出一定数量的作为每年的优秀作品，且有机会在全球进行巡回展览。</p>

                    <p>自2012年以来，“流明数码艺术大奖”已经在全球超过10个城市举办了30多场展览及活动，其中包括美国纽约、英国伦敦、希腊雅典、阿姆斯特丹、英国卡迪夫、中国香港以及中国上海等。通过与学术伙伴合作，“流明数码艺术大奖”在每场展览举办同期，并组织了多场研讨会，艺术家讲座以及频道座谈会。</p>

                    <p>远远超过了一个奖项，“流明“致力于创建一个数码艺术领域的运动，为入围、候选以及获奖艺术家们提供一个网络平台以及多种机会。2015年观众选择奖获得者、艺术家Fabiano Mixo说：“流明“是科技与艺术，研究与实践的集合地，想法与创意集聚一堂。这完全比一个展示平台的意义大的多！“</p>
                    <div class="contact">{{$t('global.联系')}}：huijun_guan@163.com </div>
                </div>
            </div>
            <comment></comment>
        </div>
        <competitionRight :onOff="true"></competitionRight>
    </div>
  </main-layout>
</template>

<script>
  import MainLayout from "@/layouts/MainLayout"
  import pages from '@/components/pages.vue'
  import comment from '@/components/comment.vue'
  import competitionRight from '@/components/competitionRight.vue'

  export default {
      name:'onOffaboutOwner',
      metaInfo () {
            return {
                title: this.$t('global.关于主办方') + " | MANA"
            }
        },
      data(){
          return{
              contentIndex:3,
              contentTab:[this.$t('global.活动介绍'),this.$t('global.报名人员'),this.$t('global.活动照片'),this.$t('global.关于主办方')],
          }
      },
    components: {
      MainLayout,
      pages,
      comment,
      competitionRight
    },
      methods:{
          changeIndex(index) {
              this.contentIndex = index
          }
      }

  }
</script>
<style lang="stylus" scoped>
.left-content
    width 10.8rem
    margin-top 0.2rem
    padding 0.4rem 0.6rem
    background-color #ffffff
    .title
        color #333333
        font-size 0.39rem
        font-weight bold
    .type
        color #777777
        font-size 0.18rem
        margin-top 0.12rem
    .bjimg
        margin-top 0.39rem
        width 10.8rem
        height 6.12rem
        background url("/static/specialCompetitiom/speCombj.png") no-repeat
        background-size cover
    .special-content
        color #333333
        font-size .16rem
        p
            margin-top 0.36rem
        .contact
            font-size 0.18rem
            color #777777
            margin-top 0.53rem
.container
    display flex
    .left-wrap
      margin-top 0.4rem
.left
    display flex
    height 1rem
    width 10.8rem
    padding 0 0.6rem
    flex-wrap nowrap
    background-color #ffffff
    justify-content space-around
    .head
        font-size 0.26rem
        line-height 1rem
        color #707070
   .choose
       color #333333
       border-bottom 2px solid #333333

.banner
    width 100%
    height 6rem
    background url("/static/identification/Header05.png") no-repeat
    background-size 100%
</style>



// WEBPACK FOOTER //
// src/pages/activity/onOffLineActivity/onOffaboutOwner.vue